var _g, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g4, _path0, _g5, _g6, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g7, _path17, _g8, _g9, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 98,
    viewBox: "0 0 105 98",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1410141034"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1410140984",
    filter: "url(#filter0_d_1792_4934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.1282 79.5468L39.2952 75.7994L48.5389 46.1615L68.4246 52.9426L60.1282 79.5468Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.505 23.3861C59.505 23.3861 65.4072 24.9824 66.5073 28.1168C66.8025 28.9566 65.5125 36.7558 56.2895 40.405L51.5146 38.9159L59.5052 23.3874L59.505 23.3861Z",
    fill: "url(#paint0_linear_1792_4934)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.4131 32.8312C53.8742 29.6752 53.3176 23.7948 51.5547 21.7327C49.7902 19.6695 44.5279 18.8153 41.1643 19.1113C40.4975 19.1703 39.907 19.3357 39.3941 19.5908C40.6094 19.4936 41.978 19.6554 43.0876 20.5116C47.3276 23.7845 47.7991 33.5449 47.6231 38.0029L49.8005 38.3802C49.8005 38.3802 52.9534 35.987 53.4131 32.8312Z",
    fill: "url(#paint1_linear_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.6306 22.2039C44.1822 21.5383 43.6721 20.9621 43.0898 20.5125C41.9802 19.6563 40.6101 19.4934 39.3964 19.5918C37.6355 20.4689 36.8255 22.4578 37.3115 25.2901C38.291 30.9998 44.3872 37.4429 44.3872 37.4429L47.624 38.0041C47.6733 36.7497 47.6726 35.0744 47.549 33.2416C44.314 28.866 44.3193 24.4839 44.6306 22.2039Z",
    fill: "url(#paint2_linear_1792_4934)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M60.2298 23.6777C56.0092 21.0466 49.6654 34.7219 49.3322 37.425L51.512 38.9143C54.8324 37.0908 63.2189 25.5423 60.2298 23.6777Z",
    fill: "url(#paint3_linear_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.8483 65.738L39.2948 75.7998L48.5384 46.1619L24.1447 39.1338L15.8483 65.738Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    filter: "url(#filter1_d_1792_4934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1545 54.8966L48.2068 47.2272L51.4127 36.9512L73.047 45.6232L70.1545 54.8966Z",
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    filter: "url(#filter2_d_1792_4934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6034 40.1249L48.2058 47.2265L51.4117 36.9505L24.4945 30.8517L21.6034 40.1249Z",
    fill: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M53.5595 37.832L51.4127 36.9509L39.2964 75.8001L41.5904 76.213L53.5595 37.832Z",
    fill: "url(#paint4_linear_1792_4934)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M65.8641 53.3974L68.0475 54.1605L60.1304 79.5476L57.8351 79.1432L65.8641 53.3974Z",
    fill: "url(#paint5_linear_1792_4934)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M49.1596 36.4073L51.4121 36.95L39.2958 75.7992L37.1597 74.8835L49.1596 36.4073Z",
    fill: "url(#paint6_linear_1792_4934)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M25.9933 40.9803L23.7667 40.3542L15.8505 65.7384L18.13 66.1959L25.9933 40.9803Z",
    fill: "url(#paint7_linear_1792_4934)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M47.1747 50.5366L48.2063 47.2267L23.7657 40.3539L22.9458 42.9812L47.1747 50.5366Z",
    fill: "url(#paint8_linear_1792_4934)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M40.8976 70.6662L39.2966 75.7998L15.8501 65.738L16.67 63.1106L40.8976 70.6662Z",
    fill: "url(#paint9_linear_1792_4934)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M40.8873 70.6636L39.2863 75.7972L60.1279 79.5473L60.9478 76.9199L40.8873 70.6636Z",
    fill: "url(#paint10_linear_1792_4934)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M47.1755 50.5371L48.2071 47.2272L68.0468 54.1607L67.2282 56.7879L47.1755 50.5371Z",
    fill: "url(#paint11_linear_1792_4934)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M40.9954 34.4357L29.4182 71.5592L31.5847 57.9023L34.2795 47.0694L40.9954 34.4357Z",
    fill: "#E3D1D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M23.2724 68.931C25.3215 69.8077 27.3706 70.6844 29.4197 71.5611C31.9054 58.7987 35.7872 46.3494 40.9969 34.4376C38.8453 33.918 36.6949 33.3982 34.5433 32.8787C29.5117 44.4606 25.7342 56.547 23.2724 68.931Z",
    fill: "url(#paint12_linear_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M59.6595 40.2564L48.0823 77.3799L55.3486 66.9229L61.0462 46.8886L59.6595 40.2564Z",
    fill: "#E3D1D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M54.6903 78.5813C52.4885 78.1807 50.2854 77.7803 48.0823 77.3799C53.2919 65.468 57.1738 53.0188 59.6595 40.2564C61.7189 41.0795 63.7785 41.9039 65.838 42.727C63.4027 55.0396 59.6648 67.0594 54.6905 78.5827L54.6903 78.5813Z",
    fill: "url(#paint13_linear_1792_4934)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M77.5247 6.96674L76.0211 7.04839L76.033 7.24113C72.8103 8.26591 70.5651 11.9563 70.82 16.2156C71.0727 20.4761 73.7418 23.8983 77.0655 24.5673L77.0774 24.7601L78.581 24.6784C82.5759 24.4612 85.5782 20.3205 85.2857 15.4296C84.9941 10.5394 81.5196 6.74956 77.5247 6.96674Z",
    fill: "url(#paint14_linear_1792_4934)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1792_4934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 6,
    width: 16,
    height: 19
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M77.5247 6.96674L76.0211 7.04839L76.033 7.24113C72.8103 8.26591 70.5651 11.9563 70.82 16.2156C71.0727 20.4761 73.7418 23.8983 77.0655 24.5673L77.0774 24.7601L78.581 24.6784C82.5759 24.4612 85.5782 20.3205 85.2857 15.4296C84.9941 10.5394 81.5196 6.74956 77.5247 6.96674Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1792_4934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M75.0307 7.09854L75.0459 7.37048L85.2305 6.78383L85.2152 6.51189L75.0307 7.09854Z",
    fill: "url(#paint15_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M75.057 7.6114L75.0723 7.8833L85.2567 7.29479L85.2415 7.02289L75.057 7.6114Z",
    fill: "url(#paint16_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M75.0853 8.12629L75.1006 8.39819L85.2851 7.80968L85.2698 7.53778L75.0853 8.12629Z",
    fill: "url(#paint17_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M75.1136 8.64021L75.1289 8.91211L85.3134 8.3236L85.2981 8.0517L75.1136 8.64021Z",
    fill: "url(#paint18_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M75.1419 9.15315L75.1572 9.42505L85.3417 8.83654L85.3264 8.56464L75.1419 9.15315Z",
    fill: "url(#paint19_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M75.1712 9.66718L75.1865 9.93909L85.371 9.35058L85.3557 9.07868L75.1712 9.66718Z",
    fill: "url(#paint20_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M75.1986 10.1801L75.2139 10.452L85.3983 9.86352L85.3831 9.59161L75.1986 10.1801Z",
    fill: "url(#paint21_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M75.2269 10.6951L75.2422 10.967L85.4267 10.3785L85.4114 10.1066L75.2269 10.6951Z",
    fill: "url(#paint22_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M75.2562 11.2078L75.2715 11.4797L85.456 10.8912L85.4407 10.6193L75.2562 11.2078Z",
    fill: "url(#paint23_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M75.2835 11.7221L75.2988 11.994L85.4833 11.4055L85.468 11.1336L75.2835 11.7221Z",
    fill: "url(#paint24_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M75.3119 12.2359L75.3271 12.5078L85.5116 11.9193L85.4963 11.6474L75.3119 12.2359Z",
    fill: "url(#paint25_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M75.3422 12.7495L75.3574 13.0215L85.542 12.4348L85.5268 12.1629L75.3422 12.7495Z",
    fill: "url(#paint26_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M75.3685 13.2639L75.3838 13.5358L85.5683 12.9473L85.553 12.6754L75.3685 13.2639Z",
    fill: "url(#paint27_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M75.3998 13.7774L75.415 14.0493L85.5996 13.4627L85.5844 13.1907L75.3998 13.7774Z",
    fill: "url(#paint28_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M75.4251 14.2908L75.4404 14.5627L85.6249 13.9742L85.6096 13.7023L75.4251 14.2908Z",
    fill: "url(#paint29_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M75.4535 14.8037L75.4688 15.0756L85.6532 14.4871L85.6379 14.2152L75.4535 14.8037Z",
    fill: "url(#paint30_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M75.4818 15.3184L75.4971 15.5903L85.6815 15.0018L85.6663 14.7299L75.4818 15.3184Z",
    fill: "url(#paint31_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M75.5091 15.8327L75.5244 16.1046L85.7089 15.5161L85.6936 15.2442L75.5091 15.8327Z",
    fill: "url(#paint32_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M75.5394 16.3454L75.5547 16.6173L85.7392 16.0288L85.7239 15.7569L75.5394 16.3454Z",
    fill: "url(#paint33_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M75.5677 16.8602L75.583 17.1321L85.7675 16.5436L85.7522 16.2717L75.5677 16.8602Z",
    fill: "url(#paint34_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M75.5951 17.3724L75.6104 17.6443L85.7948 17.0558L85.7795 16.7839L75.5951 17.3724Z",
    fill: "url(#paint35_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M75.6244 17.8872L75.6396 18.1591L85.8241 17.5705L85.8088 17.2986L75.6244 17.8872Z",
    fill: "url(#paint36_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M75.6507 18.4003L75.666 18.6722L85.8505 18.0837L85.8352 17.8118L75.6507 18.4003Z",
    fill: "url(#paint37_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M75.68 18.9141L75.6953 19.186L85.8798 18.5975L85.8645 18.3256L75.68 18.9141Z",
    fill: "url(#paint38_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M75.7084 19.4297L75.7236 19.7017L85.9082 19.115L85.893 18.8431L75.7084 19.4297Z",
    fill: "url(#paint39_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M75.7367 19.9411L75.752 20.213L85.9364 19.6245L85.9211 19.3526L75.7367 19.9411Z",
    fill: "url(#paint40_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M75.765 20.4568L75.7803 20.7288L85.9648 20.1421L85.9496 19.8702L75.765 20.4568Z",
    fill: "url(#paint41_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M75.7933 20.9697L75.8086 21.2416L85.9931 20.6531L85.9778 20.3812L75.7933 20.9697Z",
    fill: "url(#paint42_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M75.8226 21.4847L75.8379 21.7566L86.0225 21.1699L86.0072 20.898L75.8226 21.4847Z",
    fill: "url(#paint43_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M75.8499 21.9967L75.8652 22.2686L86.0497 21.68L86.0344 21.4081L75.8499 21.9967Z",
    fill: "url(#paint44_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M75.8783 22.5117L75.8936 22.7836L86.078 22.1951L86.0627 21.9232L75.8783 22.5117Z",
    fill: "url(#paint45_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M75.9066 23.0265L75.9219 23.2985L86.1065 22.7118L86.0912 22.4399L75.9066 23.0265Z",
    fill: "url(#paint46_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M75.9349 23.5386L75.9502 23.8105L86.1347 23.222L86.1194 22.9501L75.9349 23.5386Z",
    fill: "url(#paint47_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M75.9622 24.0517L75.9775 24.3236L86.162 23.7351L86.1467 23.4632L75.9622 24.0517Z",
    fill: "url(#paint48_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M75.9916 24.5674L76.0068 24.8394L86.1914 24.2527L86.1762 23.9808L75.9916 24.5674Z",
    fill: "url(#paint49_radial_1792_4934)"
  })))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M77.5225 6.95891L77.5379 7.20904C81.3902 6.99984 84.7573 10.6909 85.0402 15.4368C85.3232 20.1826 82.416 24.2152 78.5636 24.4244L78.579 24.6745C82.5749 24.4573 85.5769 20.315 85.2853 15.4237C84.9942 10.5314 81.5183 6.74168 77.5225 6.95891Z",
    fill: "url(#paint50_radial_1792_4934)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M83.7392 15.5162C83.449 10.6048 79.9945 6.80036 76.0233 7.01875C72.0521 7.23714 69.0681 11.3957 69.3583 16.3071C69.6485 21.2185 73.1031 25.0229 77.0742 24.8045C81.0454 24.5861 84.0294 20.4276 83.7392 15.5162Z",
    fill: "url(#paint51_linear_1792_4934)",
    stroke: "#F2BA3D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M83.2552 15.5428C82.9845 10.9617 79.7624 7.41304 76.0584 7.61674C72.3544 7.82044 69.5712 11.6993 69.8419 16.2804C70.1126 20.8616 73.3347 24.4102 77.0387 24.2065C80.7427 24.0028 83.5259 20.1239 83.2552 15.5428Z",
    fill: "url(#paint52_linear_1792_4934)",
    stroke: "#F2BA3D",
    strokeWidth: 1.87,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M81.5307 15.6412C81.3272 12.1965 78.9319 9.5266 76.1808 9.6779C73.4297 9.8292 71.3644 12.7444 71.568 16.1891C71.7715 19.6339 74.1668 22.3037 76.9179 22.1524C79.669 22.0011 81.7342 19.086 81.5307 15.6412Z",
    fill: "url(#paint53_linear_1792_4934)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M81.5601 15.6423C81.7637 19.0506 79.7146 21.9378 76.9755 22.124L76.9212 22.1268C74.1532 22.2772 71.7441 19.6182 71.5394 16.1865C71.3349 12.7565 73.4132 9.85445 76.1811 9.70399L76.2355 9.70119C78.9795 9.58892 81.3578 12.2362 81.5601 15.6423Z",
    fill: "url(#paint54_linear_1792_4934)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M81.9711 15.6458C82.1746 19.0542 80.1255 21.9414 77.3865 22.1276C74.6409 22.2401 72.2626 19.5928 72.059 16.1845C71.8557 12.7778 73.9048 9.89049 76.6464 9.70471C79.3904 9.59244 81.7687 12.2397 81.9711 15.6458Z",
    fill: "#FFFFE1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M81.5609 15.642C81.7645 19.0504 79.7154 21.9376 76.9763 22.1238C74.2307 22.2364 71.8524 19.5891 71.6488 16.1807C71.4456 12.774 73.4947 9.88671 76.2363 9.70093C78.9803 9.58866 81.3586 12.236 81.5609 15.642Z",
    fill: "url(#paint55_linear_1792_4934)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M79.193 10.7222C78.464 10.2815 77.645 10.0497 76.7894 10.0842C74.0446 10.2701 71.9931 13.1604 72.1966 16.5707C72.3207 18.6431 73.248 20.4344 74.5738 21.4968C72.9613 20.5227 71.7911 18.5362 71.6511 16.1892C71.4476 12.7789 73.4981 9.88798 76.2429 9.70201C77.319 9.65836 78.3391 10.0377 79.193 10.7222Z",
    fill: "url(#paint56_linear_1792_4934)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M71.0638 10.3608C72.279 8.52609 74.0912 7.41305 76.0376 7.30747C77.8965 7.20681 79.6993 8.00028 81.1147 9.54343C82.5415 11.0987 83.403 13.2258 83.5399 15.5331C83.669 17.6998 83.1355 19.8071 82.0376 21.4647C80.8225 23.2994 79.0096 24.4134 77.0648 24.5187C75.2059 24.6194 73.4031 23.8259 71.9877 22.2827C70.5609 20.7275 69.6994 18.6004 69.5625 16.2931C69.4315 14.1251 69.9659 12.0184 71.0638 10.3608ZM70.8608 10.2188C69.7743 11.8591 69.1797 13.9983 69.3166 16.3056C69.6082 21.1958 73.0833 24.9846 77.0783 24.7675C79.1893 24.6532 81.0233 23.4427 82.2403 21.6051C83.3268 19.9648 83.9214 17.8256 83.7845 15.5183C83.4929 10.6281 80.0184 6.83828 76.0235 7.05547C73.9111 7.17169 72.0778 8.3812 70.8608 10.2188Z",
    fill: "url(#paint57_radial_1792_4934)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M78.3373 13.6108L78.2948 12.8885L74.8188 13.0773L74.8614 13.7996L75.7875 13.7491C76.0842 13.7413 76.3507 13.9502 76.4821 14.2588L74.8941 14.3448L74.9366 15.0671L76.5237 14.9805C76.429 15.3028 76.1872 15.5406 75.8898 15.562L74.9694 15.6123L75.0119 16.3346L76.8618 19.3247L77.6947 19.2794L75.8448 16.2893L75.9323 16.2843C76.5588 16.2439 77.0507 15.6743 77.1416 14.9467L78.4116 14.8777L78.3691 14.1553L77.0959 14.225C77.0467 14.0301 76.9738 13.8482 76.8742 13.6898L78.3363 13.6102L78.3373 13.6108Z",
    fill: "url(#paint58_linear_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M78.2139 13.6183L78.1714 12.8959L74.6955 13.0848L74.738 13.8071L75.6635 13.7575C75.9602 13.7497 76.2267 13.9586 76.3581 14.2672L74.7701 14.3532L74.8126 15.0755L76.3996 14.9889C76.305 15.3112 76.0632 15.549 75.7658 15.5704L74.8453 15.6207L74.8879 16.343L76.7378 19.3331L77.5707 19.2878L75.7207 16.2977L75.8083 16.2928C76.4348 16.2523 76.9267 15.6827 77.0176 14.9551L78.2876 14.8861L78.2451 14.1637L76.9719 14.2334C76.9227 14.0385 76.8498 13.8566 76.7501 13.6982L78.2123 13.6186L78.2139 13.6183Z",
    fill: "url(#paint59_linear_1792_4934)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    style: {
      mixBlendMode: "screen"
    },
    d: "M82.4551 15.03C81.7343 15.5657 80.6504 15.296 80.037 14.4266C79.4227 13.5565 79.5097 12.4198 80.2328 11.8828C80.9556 11.3484 82.0381 11.62 82.6512 12.4879C83.2659 13.3554 83.1785 14.4946 82.4567 15.0297L82.4551 15.03Z",
    fill: "url(#paint60_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    style: {
      mixBlendMode: "screen"
    },
    d: "M88.7989 12.2866C88.8199 12.4238 85.1913 13.0906 80.6954 13.7757C76.1989 14.4618 76.5547 14.2209 74.5462 14.5543C72.3013 14.9278 76.1252 13.9641 80.6213 13.2806C85.1194 12.5942 88.78 12.1482 88.8004 12.2863L88.7989 12.2866Z",
    fill: "url(#paint61_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    style: {
      mixBlendMode: "screen"
    },
    d: "M82.3587 21.1383C82.2253 21.1562 81.6363 17.4173 81.0437 12.7846C80.4497 8.15383 80.6797 8.52444 80.3882 6.45643C80.0626 4.14356 80.9352 8.09067 81.5266 12.7211C82.1192 17.3538 82.4925 21.122 82.3581 21.1393L82.3587 21.1383Z",
    fill: "url(#paint62_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    style: {
      mixBlendMode: "screen"
    },
    d: "M79.268 16.5845C79.2186 16.5501 80.1083 15.121 81.2539 13.3943C82.401 11.6674 83.3717 10.2963 83.4211 10.3308C83.4721 10.365 82.582 11.7924 81.4343 13.5203C80.2887 15.247 79.3189 16.6187 79.268 16.5845Z",
    fill: "url(#paint63_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    style: {
      mixBlendMode: "screen"
    },
    d: "M84.3799 15.5705C84.3463 15.6212 82.9595 14.7159 81.2816 13.55C79.6051 12.3823 78.2719 11.394 78.3049 11.3443C78.3385 11.2936 79.7238 12.1992 81.4026 13.3657C83.0804 14.5315 84.4133 15.5182 84.379 15.5698L84.3799 15.5705Z",
    fill: "url(#paint64_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    style: {
      mixBlendMode: "screen"
    },
    d: "M81.6508 15.5826C81.2805 15.6389 80.8424 14.7314 80.6724 13.5567C80.5019 12.3829 80.6637 11.3853 81.0353 11.3313C81.406 11.2766 81.8438 12.1825 82.0137 13.3572C82.1836 14.5319 82.0227 15.5301 81.6508 15.5826Z",
    fill: "url(#paint65_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    style: {
      mixBlendMode: "screen"
    },
    d: "M79.3062 13.9458C79.2182 13.5717 80.0609 13.0504 81.1855 12.7796C82.3101 12.5088 83.2937 12.5927 83.3795 12.9681C83.4675 13.3422 82.6266 13.8649 81.5017 14.134C80.3762 14.4042 79.3936 14.3209 79.3078 13.9455L79.3062 13.9458Z",
    fill: "url(#paint66_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    style: {
      mixBlendMode: "screen"
    },
    d: "M80.817 14.2517C80.6787 14.1551 80.8009 13.7199 81.0925 13.2819C81.3835 12.8448 81.7329 12.5685 81.8695 12.6654C82.0087 12.7627 81.8853 13.1956 81.594 13.6352C81.3033 14.0739 80.9562 14.349 80.8163 14.2527L80.817 14.2517Z",
    fill: "url(#paint67_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    style: {
      mixBlendMode: "screen"
    },
    d: "M82.0891 14.0351C81.989 14.1715 81.5727 14.0237 81.1609 13.7049C80.7496 13.3851 80.4966 13.0159 80.5969 12.8811C80.697 12.7447 81.1117 12.8928 81.5236 13.2116C81.9364 13.5311 82.1885 13.8996 82.0884 14.036L82.0891 14.0351Z",
    fill: "url(#paint68_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    style: {
      mixBlendMode: "screen"
    },
    d: "M84.1358 15.4116C85.1809 13.8337 84.7776 11.6799 83.235 10.6011C81.6924 9.52221 79.5946 9.92679 78.5495 11.5047C77.5044 13.0827 77.9078 15.2364 79.4504 16.3153C80.993 17.3941 83.0907 16.9895 84.1358 15.4116Z",
    fill: "url(#paint69_radial_1792_4934)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M88.1432 64.4458L86.2199 64.4214L86.1827 64.6746C81.8303 65.7344 77.991 70.3672 77.1587 75.9625C76.3233 81.5592 78.7704 86.2699 82.7915 87.4353L82.7543 87.6885L84.6775 87.7128C89.7875 87.7772 94.706 82.6212 95.6619 76.1961C96.6189 69.772 93.2531 64.5101 88.1432 64.4458Z",
    fill: "url(#paint70_linear_1792_4934)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1792_4934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 64,
    width: 20,
    height: 24
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "clippath_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M88.1422 64.4455L86.2189 64.4212L86.1817 64.6744C81.8293 65.7341 77.9901 70.3669 77.1577 75.9622C76.3223 81.5589 78.7694 86.2697 82.7905 87.435L82.7533 87.6882L84.6765 87.7126C89.7865 87.7769 94.705 82.6209 95.661 76.1959C96.6179 69.7718 93.2522 64.5099 88.1422 64.4455Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1792_4934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M84.9578 64.4015L84.9033 64.7587L97.9395 64.8796L97.994 64.5225L84.9578 64.4015Z",
    fill: "url(#paint71_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M84.8522 65.075L84.7979 65.4321L97.8345 65.5506L97.8888 65.1935L84.8522 65.075Z",
    fill: "url(#paint72_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M84.7497 65.7519L84.6953 66.109L97.7319 66.2275L97.7863 65.8704L84.7497 65.7519Z",
    fill: "url(#paint73_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M84.6452 66.4259L84.5908 66.783L97.6274 66.9015L97.6818 66.5444L84.6452 66.4259Z",
    fill: "url(#paint74_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M84.5417 67.1L84.4873 67.4572L97.5239 67.5757L97.5783 67.2185L84.5417 67.1Z",
    fill: "url(#paint75_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M84.4391 67.7749L84.3848 68.132L97.4214 68.2505L97.4757 67.8934L84.4391 67.7749Z",
    fill: "url(#paint76_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M84.3337 68.4488L84.2793 68.8059L97.3159 68.9244L97.3703 68.5673L84.3337 68.4488Z",
    fill: "url(#paint77_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M84.2311 69.1246L84.1768 69.4817L97.2134 69.6002L97.2677 69.2431L84.2311 69.1246Z",
    fill: "url(#paint78_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M84.1296 69.7983L84.0752 70.1554L97.1118 70.2739L97.1662 69.9168L84.1296 69.7983Z",
    fill: "url(#paint79_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M84.0251 70.4736L83.9707 70.8307L97.0073 70.9492L97.0617 70.5921L84.0251 70.4736Z",
    fill: "url(#paint80_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M83.9216 71.1484L83.8672 71.5055L96.9038 71.624L96.9582 71.2669L83.9216 71.1484Z",
    fill: "url(#paint81_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M83.821 71.823L83.7666 72.1802L96.8028 72.3011L96.8573 71.944L83.821 71.823Z",
    fill: "url(#paint82_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M83.7145 72.4984L83.6602 72.8555L96.6968 72.974L96.7511 72.6169L83.7145 72.4984Z",
    fill: "url(#paint83_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M83.614 73.1726L83.5596 73.5298L96.5958 73.6507L96.6502 73.2936L83.614 73.1726Z",
    fill: "url(#paint84_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M83.5075 73.8465L83.4531 74.2036L96.4897 74.3221L96.5441 73.965L83.5075 73.8465Z",
    fill: "url(#paint85_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M83.404 74.5205L83.3496 74.8776L96.3862 74.9961L96.4406 74.639L83.404 74.5205Z",
    fill: "url(#paint86_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M83.2985 75.1958L83.2441 75.5529L96.2807 75.6714L96.3351 75.3143L83.2985 75.1958Z",
    fill: "url(#paint87_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M83.196 75.8725L83.1416 76.2296L96.1782 76.3481L96.2326 75.991L83.196 75.8725Z",
    fill: "url(#paint88_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M83.0934 76.5445L83.0391 76.9016L96.0757 77.0201L96.13 76.663L83.0934 76.5445Z",
    fill: "url(#paint89_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M82.9889 77.2207L82.9346 77.5778L95.9712 77.6963L96.0256 77.3392L82.9889 77.2207Z",
    fill: "url(#paint90_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M82.8864 77.894L82.832 78.2511L95.8686 78.3696L95.923 78.0125L82.8864 77.894Z",
    fill: "url(#paint91_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M82.7839 78.5695L82.7295 78.9266L95.7661 79.0451L95.8205 78.688L82.7839 78.5695Z",
    fill: "url(#paint92_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M82.6784 79.2435L82.624 79.6006L95.6606 79.7191L95.715 79.362L82.6784 79.2435Z",
    fill: "url(#paint93_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M82.5768 79.9183L82.5225 80.2754L95.5591 80.3939L95.6134 80.0368L82.5768 79.9183Z",
    fill: "url(#paint94_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M82.4714 80.5955L82.417 80.9526L95.4532 81.0736L95.5077 80.7164L82.4714 80.5955Z",
    fill: "url(#paint95_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M82.3708 81.2673L82.3164 81.6244L95.353 81.7429L95.4074 81.3858L82.3708 81.2673Z",
    fill: "url(#paint96_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M82.2664 81.9445L82.2119 82.3016L95.2481 82.4226L95.3026 82.0654L82.2664 81.9445Z",
    fill: "url(#paint97_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M82.1608 82.6179L82.1064 82.975L95.1431 83.0935L95.1974 82.7364L82.1608 82.6179Z",
    fill: "url(#paint98_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M82.0603 83.2948L82.0059 83.652L95.0421 83.7729L95.0965 83.4158L82.0603 83.2948Z",
    fill: "url(#paint99_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M81.9548 83.9663L81.9004 84.3234L94.937 84.4419L94.9914 84.0848L81.9548 83.9663Z",
    fill: "url(#paint100_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M81.8522 84.6433L81.7979 85.0004L94.8345 85.1189L94.8888 84.7618L81.8522 84.6433Z",
    fill: "url(#paint101_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M81.7488 85.3202L81.6943 85.6774L94.7306 85.7983L94.785 85.4412L81.7488 85.3202Z",
    fill: "url(#paint102_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M81.6462 85.9916L81.5918 86.3488L94.6284 86.4673L94.6828 86.1102L81.6462 85.9916Z",
    fill: "url(#paint103_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M81.5407 86.6654L81.4863 87.0225L94.5229 87.141L94.5773 86.7839L81.5407 86.6654Z",
    fill: "url(#paint104_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M81.4382 87.3428L81.3838 87.7L94.42 87.8209L94.4745 87.4637L81.4382 87.3428Z",
    fill: "url(#paint105_radial_1792_4934)"
  })))))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M88.1436 64.4358L88.0953 64.7644C93.0228 64.8268 96.2795 69.9502 95.3508 76.1846C94.4221 82.419 89.6531 87.4418 84.7256 87.3794L84.6772 87.7081C89.7884 87.7724 94.707 82.6143 95.6641 76.1888C96.6224 69.7621 93.2548 64.5002 88.1436 64.4358Z",
    fill: "url(#paint106_radial_1792_4934)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M93.6837 76.1744C94.6481 69.7228 91.3116 64.4434 86.2313 64.3827C81.151 64.322 76.2508 69.5029 75.2863 75.9546C74.3219 82.4062 77.6584 87.6856 82.7387 87.7463C87.819 87.807 92.7192 82.6261 93.6837 76.1744Z",
    fill: "url(#paint107_linear_1792_4934)",
    stroke: "#F2BA3D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M93.0627 76.1666C93.9623 70.1488 90.8503 65.2245 86.1119 65.1679C81.3734 65.1113 76.8029 69.9438 75.9033 75.9616C75.0037 81.9794 78.1157 86.9037 82.8542 86.9603C87.5926 87.0169 92.1632 82.1844 93.0627 76.1666Z",
    fill: "url(#paint108_linear_1792_4934)",
    stroke: "#F2BA3D",
    strokeWidth: 1.87,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M90.8558 76.1451C91.5322 71.6201 89.2275 67.9177 85.708 67.8756C82.1885 67.8336 78.787 71.4678 78.1106 75.9928C77.4341 80.5179 79.7389 84.2202 83.2583 84.2623C86.7778 84.3044 90.1793 80.6702 90.8558 76.1451Z",
    fill: "url(#paint109_linear_1792_4934)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M90.8937 76.1496C90.2272 80.627 86.8537 84.226 83.34 84.2306L83.2705 84.2295C79.73 84.1849 77.4047 80.4955 78.0761 75.9875C78.7474 71.4816 82.1618 67.8657 85.7023 67.9103L85.7718 67.9114C89.2717 68.0039 91.5611 71.6753 90.8937 76.1496Z",
    fill: "url(#paint110_linear_1792_4934)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M91.414 76.19C90.7475 80.6674 87.374 84.2665 83.8603 84.2711C80.3583 84.1788 78.0689 80.5075 78.7354 76.03C79.4018 71.5548 82.7754 67.9557 86.2921 67.9518C89.7921 68.0443 92.0815 71.7156 91.414 76.19Z",
    fill: "#FFFFE1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M90.8964 76.1496C90.2299 80.627 86.8564 84.2261 83.3427 84.2307C79.8407 84.1384 77.5513 80.4671 78.2178 75.9896C78.8842 71.5144 82.2578 67.9153 85.7746 67.9114C89.2745 68.0039 91.5639 71.6752 90.8964 76.1496Z",
    fill: "url(#paint111_linear_1792_4934)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M89.2341 69.5054C88.4318 68.8651 87.459 68.4904 86.3679 68.4608C82.847 68.4646 79.4697 72.0675 78.8025 76.5474C78.3977 79.2699 79.0846 81.6946 80.4728 83.2003C78.698 81.7852 77.757 79.0838 78.2162 76.0007C78.8833 71.5207 82.2596 67.9169 85.7805 67.9131C87.153 67.9498 88.3399 68.5352 89.2341 69.5054Z",
    fill: "url(#paint112_linear_1792_4934)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M79.0539 68.3227C81.0876 66.0281 83.6807 64.7298 86.1703 64.7615C88.5479 64.792 90.6123 65.9875 91.9836 68.1301C93.366 70.2896 93.8786 73.1479 93.4263 76.1788C93.0022 79.0251 91.7564 81.7359 89.9189 83.8091C87.8851 86.1037 85.291 87.4031 82.8034 87.3712C80.4258 87.3407 78.3615 86.1452 76.9902 84.0026C75.6078 81.8431 75.0952 78.9848 75.5475 75.9539C75.9695 73.1057 77.2163 70.3958 79.0539 68.3227ZM78.8356 68.1191C77.0173 70.1707 75.6856 72.9178 75.2332 75.9487C74.2763 82.3728 77.6431 87.6335 82.7531 87.6979C85.4533 87.7325 88.1002 86.3086 90.1372 84.0104C91.9555 81.9589 93.2872 79.2118 93.7396 76.1809C94.6965 69.7568 91.3308 64.4949 86.2208 64.4305C83.5185 64.3983 80.8726 65.8209 78.8356 68.1191Z",
    fill: "url(#paint113_radial_1792_4934)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M87.3686 73.2098L87.5107 72.261L83.0646 72.2048L82.9225 73.1536L84.1072 73.1683C84.4845 73.184 84.7649 73.4805 84.8473 73.8959L82.8162 73.8698L82.6741 74.8187L84.7042 74.8438C84.4971 75.2573 84.127 75.5473 83.7451 75.5493L82.5677 75.5348L82.4257 76.4837L83.9541 80.5575L85.0195 80.5708L83.491 76.497L83.6031 76.4982C84.4062 76.4999 85.1826 75.7976 85.4947 74.8535L87.1192 74.8739L87.2612 73.9251L85.6326 73.9051C85.6232 73.6459 85.5803 73.4014 85.4972 73.1855L87.3676 73.2089L87.3686 73.2098Z",
    fill: "url(#paint114_linear_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M87.2105 73.2089L87.3525 72.26L82.9065 72.2038L82.7644 73.1527L83.948 73.1686C84.3254 73.1842 84.6057 73.4808 84.6881 73.8961L82.657 73.8701L82.5149 74.8189L84.545 74.844C84.338 75.2575 83.9678 75.5475 83.5859 75.5496L82.4085 75.5351L82.2665 76.4839L83.795 80.5577L84.8603 80.571L83.3318 76.4973L83.4439 76.4984C84.247 76.5001 85.0234 75.7978 85.3355 74.8537L86.96 74.8742L87.102 73.9253L85.4734 73.9054C85.464 73.6461 85.4211 73.4017 85.3381 73.1858L87.2084 73.2091L87.2105 73.2089Z",
    fill: "url(#paint115_linear_1792_4934)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    style: {
      mixBlendMode: "screen"
    },
    d: "M92.1915 75.4256C91.1348 76.0637 89.8375 75.6162 89.2976 74.4251C88.7567 73.233 89.1749 71.7533 90.2347 71.1138C91.2934 70.4775 92.5886 70.9274 93.1285 72.1164C93.6706 73.3052 93.2513 74.7881 92.1936 75.4253L92.1915 75.4256Z",
    fill: "url(#paint116_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    style: {
      mixBlendMode: "screen"
    },
    d: "M100.957 72.3897C100.946 72.571 96.1776 73.1269 90.3074 73.6312C84.4361 74.1366 84.9512 73.8523 82.3214 74.1134C79.3817 74.4063 84.4778 73.4789 90.348 72.9769C96.2214 72.4712 100.971 72.2069 100.959 72.3894L100.957 72.3897Z",
    fill: "url(#paint117_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    style: {
      mixBlendMode: "screen"
    },
    d: "M90.4144 83.4097C90.2408 83.4215 90.5097 78.4779 91.0162 72.3645C91.5205 66.2536 91.7108 66.7585 91.9028 64.0272C92.1182 60.9725 92.1515 66.2133 91.644 72.3235C91.1375 78.4369 90.588 83.4001 90.4133 83.4109L90.4144 83.4097Z",
    fill: "url(#paint118_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    style: {
      mixBlendMode: "screen"
    },
    d: "M87.7395 77.1819C87.6864 77.1324 89.1988 75.3402 91.1152 73.1809C93.0338 71.0213 94.6328 69.312 94.6859 69.3615C94.7411 69.4106 93.2288 71.2007 91.3092 73.3615C89.3927 75.5208 87.7947 77.231 87.7395 77.1819Z",
    fill: "url(#paint119_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    style: {
      mixBlendMode: "screen"
    },
    d: "M94.4799 76.3013C94.4237 76.3647 92.9156 75.0592 91.1102 73.3873C89.3069 71.7131 87.8891 70.3037 87.9444 70.2415C88.0006 70.1781 89.5067 71.4839 91.313 73.1567C93.1184 74.8285 94.5363 76.2358 94.4789 76.3004L94.4799 76.3013Z",
    fill: "url(#paint120_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    style: {
      mixBlendMode: "screen"
    },
    d: "M91.0251 76.0794C90.5416 76.1208 90.2337 74.8951 90.3373 73.3432C90.4398 71.7925 90.9148 70.5014 91.3993 70.4631C91.8828 70.4238 92.1908 71.6474 92.0872 73.1992C91.9836 74.7511 91.5096 76.0432 91.0251 76.0794Z",
    fill: "url(#paint121_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    style: {
      mixBlendMode: "screen"
    },
    d: "M88.5026 73.7324C88.4927 73.2352 89.6997 72.6266 91.195 72.3704C92.6903 72.1142 93.9111 72.3098 93.9179 72.8085C93.9278 73.3056 92.7229 73.9162 91.2276 74.1702C89.7313 74.4255 88.5115 74.2308 88.5047 73.7321L88.5026 73.7324Z",
    fill: "url(#paint122_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    style: {
      mixBlendMode: "screen"
    },
    d: "M90.3313 74.2647C90.1827 74.1262 90.4551 73.5674 90.9426 73.0198C91.429 72.4733 91.9457 72.1422 92.0922 72.2809C92.2418 72.4204 91.9684 72.976 91.4809 73.5259C90.9944 74.0745 90.4809 74.4042 90.3303 74.2659L90.3313 74.2647Z",
    fill: "url(#paint123_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    style: {
      mixBlendMode: "screen"
    },
    d: "M91.9993 74.0923C91.8358 74.2621 91.3496 74.0324 90.9152 73.5793C90.4819 73.125 90.2621 72.6199 90.4255 72.4523C90.589 72.2825 91.0732 72.5125 91.5075 72.9655C91.9429 73.4195 92.1617 73.9237 91.9983 74.0935L91.9993 74.0923Z",
    fill: "url(#paint124_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    style: {
      mixBlendMode: "screen"
    },
    d: "M94.2132 76.0716C95.9624 74.0981 96.0363 71.2449 94.3783 69.6986C92.7203 68.1524 89.9583 68.4988 88.2091 70.4723C86.46 72.4457 86.3861 75.299 88.0441 76.8452C89.702 78.3914 92.4641 78.0451 94.2132 76.0716Z",
    fill: "url(#paint125_radial_1792_4934)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M18.8112 76.7361L17.893 77.2181L17.9404 77.3478C16.1486 78.9672 15.5172 82.1491 16.5584 85.0156C17.5986 87.8837 19.9678 89.4893 22.1734 89.01L22.2207 89.1396L23.1389 88.6576C25.5783 87.3767 26.5872 83.6698 25.3917 80.378C24.1968 77.0865 21.2506 75.4553 18.8112 76.7361Z",
    fill: "url(#paint126_linear_1792_4934)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1792_4934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 76,
    width: 10,
    height: 14
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "clippath_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M18.8102 76.7359L17.8921 77.2179L17.9394 77.3475C16.1477 78.9669 15.5162 82.1488 16.5574 85.0154C17.5976 87.8835 19.9668 89.4891 22.1724 89.0097L22.2198 89.1393L23.1379 88.6573C25.5773 87.3765 26.5863 83.6695 25.3907 80.3778C24.1958 77.0862 21.2496 75.455 18.8102 76.7359Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1792_4934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M17.2896 77.533L17.3555 77.7163L23.5676 74.4282L23.5018 74.2449L17.2896 77.533Z",
    fill: "url(#paint127_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M17.4127 77.8793L17.4785 78.0626L23.6902 74.7733L23.6244 74.59L17.4127 77.8793Z",
    fill: "url(#paint128_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M17.5377 78.2268L17.6035 78.41L23.8152 75.1207L23.7494 74.9374L17.5377 78.2268Z",
    fill: "url(#paint129_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M17.6617 78.5731L17.7275 78.7563L23.9392 75.467L23.8734 75.2837L17.6617 78.5731Z",
    fill: "url(#paint130_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M17.7857 78.9193L17.8516 79.1025L24.0633 75.8132L23.9974 75.6299L17.7857 78.9193Z",
    fill: "url(#paint131_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M17.9097 79.2656L17.9756 79.4489L24.1873 76.1595L24.1214 75.9762L17.9097 79.2656Z",
    fill: "url(#paint132_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M18.0328 79.6119L18.0986 79.7952L24.3103 76.5058L24.2445 76.3225L18.0328 79.6119Z",
    fill: "url(#paint133_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M18.1568 79.9589L18.2227 80.1422L24.4344 76.8529L24.3685 76.6696L18.1568 79.9589Z",
    fill: "url(#paint134_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M18.2828 80.3044L18.3486 80.4877L24.5603 77.1983L24.4945 77.015L18.2828 80.3044Z",
    fill: "url(#paint135_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M18.4058 80.6513L18.4717 80.8346L24.6834 77.5452L24.6175 77.362L18.4058 80.6513Z",
    fill: "url(#paint136_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M18.5298 80.9981L18.5957 81.1814L24.8074 77.892L24.7415 77.7088L18.5298 80.9981Z",
    fill: "url(#paint137_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M18.6558 81.3438L18.7217 81.5271L24.9338 78.239L24.868 78.0557L18.6558 81.3438Z",
    fill: "url(#paint138_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M18.7789 81.6912L18.8447 81.8745L25.0564 78.5852L24.9906 78.4019L18.7789 81.6912Z",
    fill: "url(#paint139_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M18.9039 82.0365L18.9697 82.2198L25.1819 78.9318L25.116 78.7484L18.9039 82.0365Z",
    fill: "url(#paint140_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M19.0259 82.3837L19.0918 82.567L25.3035 79.2777L25.2376 79.0944L19.0259 82.3837Z",
    fill: "url(#paint141_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M19.15 82.7296L19.2158 82.9128L25.4275 79.6235L25.3617 79.4402L19.15 82.7296Z",
    fill: "url(#paint142_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M19.274 83.0765L19.3398 83.2598L25.5515 79.9704L25.4857 79.7871L19.274 83.0765Z",
    fill: "url(#paint143_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M19.399 83.4239L19.4648 83.6072L25.6765 80.3178L25.6107 80.1346L19.399 83.4239Z",
    fill: "url(#paint144_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M19.523 83.7689L19.5889 83.9521L25.8006 80.6628L25.7347 80.4795L19.523 83.7689Z",
    fill: "url(#paint145_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M19.6461 84.1165L19.7119 84.2998L25.9236 81.0105L25.8577 80.8272L19.6461 84.1165Z",
    fill: "url(#paint146_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M19.7711 84.4617L19.8369 84.645L26.0486 81.3557L25.9827 81.1724L19.7711 84.4617Z",
    fill: "url(#paint147_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M19.8951 84.8085L19.9609 84.9918L26.1726 81.7025L26.1068 81.5192L19.8951 84.8085Z",
    fill: "url(#paint148_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M20.0181 85.1553L20.084 85.3386L26.2957 82.0493L26.2298 81.866L20.0181 85.1553Z",
    fill: "url(#paint149_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M20.1431 85.5011L20.209 85.6843L26.4207 82.395L26.3548 82.2117L20.1431 85.5011Z",
    fill: "url(#paint150_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M20.2672 85.8492L20.333 86.0325L26.5452 82.7444L26.4793 82.5611L20.2672 85.8492Z",
    fill: "url(#paint151_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M20.3912 86.194L20.457 86.3773L26.6687 83.088L26.6029 82.9047L20.3912 86.194Z",
    fill: "url(#paint152_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M20.5162 86.5415L20.582 86.7249L26.7942 83.4368L26.7283 83.2534L20.5162 86.5415Z",
    fill: "url(#paint153_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M20.6392 86.8879L20.7051 87.0712L26.9168 83.7818L26.8509 83.5985L20.6392 86.8879Z",
    fill: "url(#paint154_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M20.7652 87.2347L20.8311 87.418L27.0432 84.1299L26.9774 83.9466L20.7652 87.2347Z",
    fill: "url(#paint155_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M20.8873 87.5803L20.9531 87.7635L27.1648 84.4742L27.099 84.2909L20.8873 87.5803Z",
    fill: "url(#paint156_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M21.0123 87.9274L21.0781 88.1107L27.2898 84.8214L27.224 84.6381L21.0123 87.9274Z",
    fill: "url(#paint157_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M21.1373 88.2748L21.2031 88.4581L27.4153 85.17L27.3494 84.9867L21.1373 88.2748Z",
    fill: "url(#paint158_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M21.2603 88.6199L21.3262 88.8032L27.5379 85.5139L27.472 85.3306L21.2603 88.6199Z",
    fill: "url(#paint159_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M21.3834 88.9661L21.4492 89.1494L27.6609 85.8601L27.5951 85.6768L21.3834 88.9661Z",
    fill: "url(#paint160_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M21.5094 89.3136L21.5752 89.4969L27.7873 86.2089L27.7215 86.0255L21.5094 89.3136Z",
    fill: "url(#paint161_radial_1792_4934)"
  })))))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M18.8089 76.7313L18.8704 76.8995C21.2227 75.6646 24.0817 77.258 25.2413 80.4524C26.4008 83.6468 25.4286 87.2522 23.0762 88.4872L23.1376 88.6554C25.5776 87.3742 26.586 83.6663 25.3909 80.374C24.196 77.0809 21.2489 75.4502 18.8089 76.7313Z",
    fill: "url(#paint162_radial_1792_4934)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M24.4485 80.8757C23.2501 77.5692 20.3133 75.9222 17.8889 77.1972C15.4645 78.4721 14.4706 82.1862 15.669 85.4927C16.8674 88.7992 19.8042 90.4462 22.2286 89.1712C24.653 87.8963 25.6469 84.1822 24.4485 80.8757Z",
    fill: "url(#paint163_linear_1792_4934)",
    stroke: "#F2BA3D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M24.1521 81.031C23.0343 77.9468 20.2951 76.4106 18.0338 77.5997C15.7725 78.7889 14.8456 82.2531 15.9634 85.3373C17.0812 88.4215 19.8204 89.9577 22.0817 88.7686C24.343 87.5794 25.2699 84.1152 24.1521 81.031Z",
    fill: "url(#paint164_linear_1792_4934)",
    stroke: "#F2BA3D",
    strokeWidth: 1.87,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M23.1004 81.5874C22.2598 79.2683 20.2169 78.1042 18.5374 78.9875C16.8578 79.8707 16.1776 82.4668 17.0182 84.7859C17.8587 87.1051 19.9016 88.2691 21.5811 87.3858C23.2607 86.5026 23.9409 83.9065 23.1004 81.5874Z",
    fill: "url(#paint165_linear_1792_4934)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M23.1194 81.5799C23.9523 83.8739 23.2764 86.4461 21.6116 87.35L21.5784 87.3673C19.8882 88.2547 17.8389 87.1021 17.0003 84.7924C16.1623 82.4836 16.8533 79.8929 18.5435 79.0055L18.5767 78.9882C20.2599 78.1339 22.2876 79.2871 23.1194 81.5799Z",
    fill: "url(#paint166_linear_1792_4934)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M23.3763 81.4655C24.2093 83.7595 23.5333 86.3318 21.8685 87.2357C20.1844 88.0906 18.1567 86.9374 17.3237 84.6434C16.4912 82.3504 17.1671 79.7782 18.8336 78.8738C20.5168 78.0195 22.5445 79.1728 23.3763 81.4655Z",
    fill: "#FFFFE1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M23.1204 81.5789C23.9534 83.873 23.2775 86.4452 21.6126 87.3491C19.9285 88.204 17.9008 87.0508 17.0678 84.7568C16.2353 82.4638 16.9113 79.8916 18.5777 78.9872C20.261 78.1329 22.2887 79.2862 23.1204 81.5789Z",
    fill: "url(#paint167_linear_1792_4934)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M20.6269 78.855C20.0822 78.7573 19.5248 78.8293 18.9998 79.0953C17.3314 80.0007 16.6546 82.5757 17.488 84.871C17.9947 86.2658 18.9426 87.2392 19.9873 87.5969C18.7826 87.3813 17.6432 86.342 17.0697 84.7623C16.2363 82.4669 16.9124 79.8917 18.5808 78.9863C19.241 78.6516 19.954 78.6245 20.6269 78.855Z",
    fill: "url(#paint168_linear_1792_4934)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M15.4968 80.9068C15.8722 79.297 16.7685 78.0159 17.9571 77.392C19.0923 76.7963 20.3779 76.8334 21.578 77.4974C22.7876 78.1666 23.7642 79.3903 24.3275 80.9435C24.8569 82.4019 24.9618 84.0069 24.6226 85.4615C24.2472 87.0713 23.3506 88.3532 22.163 88.9764C21.0278 89.5721 19.7422 89.5351 18.5421 88.8711C17.3325 88.2019 16.3559 86.9782 15.7926 85.425C15.2618 83.9662 15.1575 82.3614 15.4968 80.9068ZM15.3411 80.8664C15.0054 82.3057 15.0789 83.95 15.6422 85.5032C16.8371 88.7947 19.7835 90.4251 22.2229 89.1443C23.5121 88.4677 24.4017 87.1133 24.7778 85.5009C25.1135 84.0616 25.0399 82.4173 24.4766 80.8641C23.2817 77.5725 20.3355 75.9413 17.8961 77.2222C16.6065 77.9004 15.7171 79.2539 15.3411 80.8664Z",
    fill: "url(#paint169_radial_1792_4934)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M20.6933 81.0904L20.5171 80.604L18.3946 81.7183L18.5708 82.2047L19.1362 81.9076C19.3192 81.8182 19.5282 81.8869 19.6739 82.0627L18.7041 82.5716L18.8803 83.0579L19.8493 82.5488C19.8572 82.798 19.7561 83.0305 19.5756 83.1295L19.0136 83.4248L19.1898 83.9111L20.9599 85.4505L21.4685 85.1834L19.6983 83.6441L19.7517 83.6159C20.133 83.4106 20.3209 82.8783 20.2266 82.3506L21.0021 81.9434L20.8259 81.457L20.0486 81.8655C19.9776 81.745 19.8945 81.6401 19.7998 81.5591L20.6926 81.0902L20.6933 81.0904Z",
    fill: "url(#paint170_linear_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M20.6183 81.1305L20.4422 80.6442L18.3196 81.7585L18.4958 82.2449L19.0611 81.9487C19.244 81.8592 19.453 81.9279 19.5987 82.1037L18.6289 82.6126L18.8051 83.0989L19.7741 82.5899C19.782 82.839 19.681 83.0715 19.5004 83.1705L18.9384 83.4658L19.1146 83.9522L20.8847 85.4915L21.3933 85.2244L19.6231 83.6851L19.6766 83.6569C20.0578 83.4516 20.2457 82.9193 20.1514 82.3916L20.9269 81.9844L20.7507 81.4981L19.9734 81.9066C19.9024 81.786 19.8193 81.6811 19.7246 81.6001L20.6174 81.1312L20.6183 81.1305Z",
    fill: "url(#paint171_linear_1792_4934)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.5483 80.904C23.2111 81.4777 22.4811 81.5985 21.9195 81.1723C21.3571 80.7458 21.1756 79.937 21.514 79.3617C21.8527 78.7884 22.5823 78.6693 23.1434 79.0945C23.7055 79.519 23.8873 80.3298 23.5493 80.9033L23.5483 80.904Z",
    fill: "url(#paint172_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    style: {
      mixBlendMode: "screen"
    },
    d: "M26.9251 77.2152C26.9667 77.3039 24.8482 78.7913 22.1943 80.5368C19.5401 82.2832 19.7114 82.0162 18.5315 82.8149C17.2128 83.7082 19.3911 81.9607 22.0456 80.2162C24.7007 78.4691 26.8847 77.1251 26.9261 77.2146L26.9251 77.2152Z",
    fill: "url(#paint173_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.754 85.1459C24.6747 85.196 23.5335 82.783 22.2048 79.7544C20.8758 76.7275 21.0956 76.9181 20.4857 75.5737C19.8039 74.0701 21.1646 76.5465 22.492 79.5739C23.8207 82.6025 24.8338 85.0968 24.7538 85.1467L24.754 85.1459Z",
    fill: "url(#paint174_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    style: {
      mixBlendMode: "screen"
    },
    d: "M21.8878 82.8791C21.8499 82.8692 22.1071 81.6314 22.4616 80.1157C22.8171 78.5994 23.1366 77.3786 23.1745 77.3884C23.2132 77.3975 22.9556 78.6344 22.5999 80.1515C22.2454 81.6672 21.9265 82.8882 21.8878 82.8791Z",
    fill: "url(#paint175_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.8574 80.732C24.847 80.7765 23.7969 80.5445 22.5118 80.2151C21.2271 79.884 20.1932 79.5796 20.2034 79.5359C20.2138 79.4914 21.263 79.7241 22.5488 80.0537C23.8339 80.3831 24.8673 80.6865 24.8567 80.7318L24.8574 80.732Z",
    fill: "url(#paint176_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.1637 81.5131C22.945 81.6568 22.4845 81.1546 22.1354 80.3922C21.786 79.6307 21.6799 78.8966 21.8998 78.7541C22.119 78.6114 22.579 79.1125 22.9281 79.8749C23.2773 80.6373 23.3841 81.3716 23.1637 81.5131Z",
    fill: "url(#paint177_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    style: {
      mixBlendMode: "screen"
    },
    d: "M21.3653 81.0476C21.233 80.8144 21.6491 80.2161 22.2923 79.7109C22.9356 79.2057 23.5647 78.9851 23.6958 79.2198C23.8281 79.453 23.4135 80.0517 22.7697 80.5559C22.1257 81.0609 21.4974 81.2817 21.3662 81.047L21.3653 81.0476Z",
    fill: "url(#paint178_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    style: {
      mixBlendMode: "screen"
    },
    d: "M22.3684 80.8309C22.2624 80.8033 22.2481 80.4685 22.3387 80.0837C22.4291 79.6998 22.5891 79.4102 22.6942 79.4384C22.8009 79.4661 22.8139 79.7997 22.7238 80.1856C22.634 80.5705 22.4751 80.8586 22.3682 80.8317L22.3684 80.8309Z",
    fill: "url(#paint179_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.1146 80.3213C23.0807 80.4437 22.7912 80.4596 22.469 80.3562C22.1469 80.252 21.9131 80.0689 21.9475 79.9475C21.9815 79.8251 22.2701 79.8099 22.5923 79.9132C22.9152 80.0168 23.1484 80.1997 23.1144 80.3221L23.1146 80.3213Z",
    fill: "url(#paint180_radial_1792_4934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.6722 80.6914C24.9951 79.3068 24.2979 77.935 23.115 77.6273C21.932 77.3197 20.7113 78.1927 20.3884 79.5773C20.0655 80.9619 20.7627 82.3338 21.9456 82.6414C23.1285 82.9491 24.3493 82.076 24.6722 80.6914Z",
    fill: "url(#paint181_radial_1792_4934)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1792_4934",
    x: 11.8486,
    y: 19.0543,
    width: 65.1982,
    height: 68.4933,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1792_4934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1792_4934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1792_4934",
    x: 43.207,
    y: 34.9512,
    width: 34.8398,
    height: 27.9454,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1792_4934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1792_4934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1792_4934",
    x: 16.6035,
    y: 28.8517,
    width: 39.8086,
    height: 26.3749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1792_4934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1792_4934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1792_4934",
    x1: 52.6802,
    y1: 42.7038,
    x2: 64.9201,
    y2: 24.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5C25B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57E10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1792_4934",
    x1: 49.1773,
    y1: 44.0782,
    x2: 45.7319,
    y2: 18.4904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5C25B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57E10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1792_4934",
    x1: 48.3011,
    y1: 43.3386,
    x2: 38.0225,
    y2: 16.2546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9DF7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1792_4934",
    x1: 47.7494,
    y1: 40.2257,
    x2: 60.9314,
    y2: 23.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9DF7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1792_4934",
    x1: 44.7598,
    y1: 56.1829,
    x2: 46.9677,
    y2: 56.8712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C0B1B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1792_4934",
    x1: 64.6831,
    y1: 67.1439,
    x2: 62.4765,
    y2: 66.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C0B1B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1792_4934",
    x1: 45.6164,
    y1: 56.4466,
    x2: 43.4086,
    y2: 55.7583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C0B1B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1792_4934",
    x1: 19.5897,
    y1: 52.9344,
    x2: 21.7975,
    y2: 53.6227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C0B1B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1792_4934",
    x1: 36.2097,
    y1: 43.079,
    x2: 35.1778,
    y2: 46.3888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C0B1B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1792_4934",
    x1: 26.0139,
    y1: 74.829,
    x2: 29.2073,
    y2: 66.1143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C0B1B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1792_4934",
    x1: 49.1517,
    y1: 79.4803,
    x2: 50.7523,
    y2: 74.3463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C0B1B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1792_4934",
    x1: 58.3603,
    y1: 49.9719,
    x2: 57.3284,
    y2: 53.2817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C0B1B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1792_4934",
    x1: 23.1051,
    y1: 81.814,
    x2: 38.5307,
    y2: 28.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5C25B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57E10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1792_4934",
    x1: 50.0981,
    y1: 84.4071,
    x2: 64.0379,
    y2: 37.9276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5C25B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57E10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1792_4934",
    x1: 78.4388,
    y1: 22.3101,
    x2: 77.5242,
    y2: 5.45463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6399 14.5891) rotate(-3.2967) scale(53.3173 11.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6365 14.5477) rotate(-3.30715) scale(53.3229 11.7647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6343 14.5188) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6319 14.4865) rotate(-3.30715) scale(53.3229 11.7647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6285 14.4557) rotate(-3.30715) scale(53.3229 11.7647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6283 14.4258) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.625 14.3937) rotate(-3.30715) scale(53.3229 11.7647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6227 14.3637) rotate(-3.30715) scale(53.3229 11.7647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6212 14.3289) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6181 14.3018) rotate(-3.30715) scale(53.3117 11.7622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6157 14.2694) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6143 14.2476) rotate(-3.2967) scale(53.3173 11.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6111 14.2085) rotate(-3.30715) scale(53.3117 11.7623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6119 14.1839) rotate(-3.2967) scale(53.3173 11.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6053 14.1454) rotate(-3.30715) scale(53.3117 11.7623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6043 14.1156) rotate(-3.30715) scale(53.3117 11.7622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6019 14.0841) rotate(-3.30715) scale(53.3117 11.7622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5986 14.0534) rotate(-3.30715) scale(53.3117 11.7622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5981 14.0198) rotate(-3.30715) scale(53.3117 11.7622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5959 13.992) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5927 13.9604) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5902 13.9302) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5871 13.8982) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5858 13.8682) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5845 13.8449) rotate(-3.2967) scale(53.3173 11.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.581 13.8039) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5802 13.7842) rotate(-3.2967) scale(53.3173 11.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5765 13.7436) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5755 13.7207) rotate(-3.2967) scale(53.3173 11.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5718 13.6805) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5695 13.6505) rotate(-3.30715) scale(53.3061 11.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5688 13.6246) rotate(-3.2967) scale(53.3229 11.7662)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5649 13.5898) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5616 13.5579) rotate(-3.30715) scale(53.3173 11.7635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5622 13.5327) rotate(-3.2967) scale(53.3285 11.7675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.6666 15.6211) rotate(-3.10571) scale(6.635 6.80149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1792_4934",
    x1: 77.1214,
    y1: 25.5839,
    x2: 76.6033,
    y2: 16.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1792_4934",
    x1: 77.0387,
    y1: 24.2078,
    x2: 76.1276,
    y2: 7.61394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1792_4934",
    x1: 76.1418,
    y1: 8.99911,
    x2: 76.6966,
    y2: 19.0863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1792_4934",
    x1: 76.9194,
    y1: 22.1415,
    x2: 76.0795,
    y2: 6.66137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1792_4934",
    x1: 76.8487,
    y1: 20.0209,
    x2: 75.8662,
    y2: 1.91209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1792_4934",
    x1: 76.7955,
    y1: 16.048,
    x2: 68.4889,
    y2: 10.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.5498 15.9121) rotate(-56.4826) scale(8.08697 8.07344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1792_4934",
    x1: 75.5859,
    y1: 12.6179,
    x2: 78.6069,
    y2: 18.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F98D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F66300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FF7C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1792_4934",
    x1: 75.4739,
    y1: 12.502,
    x2: 78.4755,
    y2: 18.3124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.9116 12.1794) rotate(54.7787) scale(1.91599 1.63088)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.5968 8.73505) rotate(-8.67411) scale(7.89809 0.263014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.5318 12.9889) rotate(82.7027) scale(8.10946 0.256719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.7149 12.2523) rotate(123.572) scale(3.7389 0.12127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0957 14.164) rotate(34.8127) scale(3.71528 0.120692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.4227 14.6123) rotate(81.7667) scale(2.15454 0.672204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.1394 11.9949) rotate(166.506) scale(2.10092 0.689367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.4723 13.3467) rotate(123.55) scale(0.953035 0.304522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.2178 13.9729) rotate(37.7441) scale(0.938891 0.30301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.2915 13.5083) rotate(-56.4826) scale(3.40847 3.40276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1792_4934",
    x1: 85.1397,
    y1: 84.6016,
    x2: 85.4214,
    y2: 62.4274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.778 76.2623) rotate(0.531537) scale(68.136 15.4484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.786 76.2081) rotate(0.520798) scale(68.145 15.4477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.792 76.1708) rotate(0.520798) scale(68.1378 15.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.796 76.1273) rotate(0.520798) scale(68.145 15.4477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.8 76.0872) rotate(0.520798) scale(68.145 15.4477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.808 76.0478) rotate(0.520798) scale(68.1378 15.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.811 76.0059) rotate(0.520798) scale(68.145 15.4477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.818 75.9659) rotate(0.520798) scale(68.145 15.4477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.826 75.9205) rotate(0.520798) scale(68.1378 15.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.83 75.8848) rotate(0.520798) scale(68.1307 15.4444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.835 75.8422) rotate(0.520798) scale(68.1378 15.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.84 75.8135) rotate(0.531537) scale(68.136 15.4485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.846 75.7621) rotate(0.520798) scale(68.1307 15.4445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.853 75.7296) rotate(0.531537) scale(68.136 15.4485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.856 75.6786) rotate(0.520798) scale(68.1307 15.4445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.862 75.64) rotate(0.520798) scale(68.1307 15.4444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.866 75.5978) rotate(0.520798) scale(68.1307 15.4444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.872 75.5587) rotate(0.520798) scale(68.1307 15.4444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.879 75.5133) rotate(0.520798) scale(68.1307 15.4444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.883 75.4768) rotate(0.520798) scale(68.1378 15.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.889 75.4359) rotate(0.520798) scale(68.1378 15.4461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.894 75.3956) rotate(0.520798) scale(68.1378 15.4461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.899 75.3538) rotate(0.520798) scale(68.1378 15.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.906 75.3144) rotate(0.520798) scale(68.1378 15.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.91 75.2838) rotate(0.531537) scale(68.136 15.4484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.918 75.2301) rotate(0.520798) scale(68.1378 15.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.922 75.2042) rotate(0.531537) scale(68.136 15.4484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.926 75.1506) rotate(0.520798) scale(68.1378 15.4461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.933 75.1211) rotate(0.531537) scale(68.136 15.4484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.938 75.0673) rotate(0.520798) scale(68.1378 15.4461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.945 75.0285) rotate(0.520798) scale(68.1235 15.4428)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.951 74.9954) rotate(0.531537) scale(68.1431 15.4501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.956 74.9485) rotate(0.520798) scale(68.1378 15.4461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.96 74.9063) rotate(0.520798) scale(68.1378 15.4461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.967 74.8735) rotate(0.531537) scale(68.1503 15.4517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.0352 76.1315) rotate(0.727873) scale(8.47498 8.93525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1792_4934",
    x1: 82.5871,
    y1: 88.7701,
    x2: 82.7352,
    y2: 76.3762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1792_4934",
    x1: 82.8539,
    y1: 86.962,
    x2: 83.1166,
    y2: 65.1331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1792_4934",
    x1: 85.8427,
    y1: 66.9841,
    x2: 85.6841,
    y2: 80.2535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1792_4934",
    x1: 83.2642,
    y1: 84.2486,
    x2: 83.523,
    y2: 63.8838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1792_4934",
    x1: 83.7514,
    y1: 81.468,
    x2: 84.0541,
    y2: 57.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1792_4934",
    x1: 84.7589,
    y1: 76.2647,
    x2: 75.7792,
    y2: 68.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.4854 76.0649) rotate(-48.4484) scale(11.2678 9.72318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1792_4934",
    x1: 84.159,
    y1: 71.6707,
    x2: 87.3265,
    y2: 78.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F98D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F66300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FF7C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1792_4934",
    x1: 84.0487,
    y1: 71.5093,
    x2: 87.1844,
    y2: 78.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.7482 71.4738) rotate(65.5976) scale(2.35481 2.2267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.5491 67.027) rotate(-4.91878) scale(10.2326 0.340658)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.6355 73.0233) rotate(94.7291) scale(10.651 0.327989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.7434 71.6396) rotate(131.599) scale(5.20951 0.14605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.973 74.2617) rotate(42.8226) scale(4.47442 0.168165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.9998 74.7899) rotate(93.8165) scale(2.82323 0.860813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.085 71.2524) rotate(170.321) scale(2.75515 0.882096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.1408 73.0505) rotate(131.58) scale(1.32789 0.366748)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.6502 73.8477) rotate(46.2126) scale(1.13141 0.421942)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.1329 73.333) rotate(-48.4484) scale(4.7491 4.09808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1792_4934",
    x1: 22.5596,
    y1: 87.0638,
    x2: 17.0027,
    y2: 76.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5245 76.0173) rotate(-27.8923) scale(36.7349 8.32888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5142 75.9897) rotate(-27.903) scale(36.7398 8.32848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5075 75.9705) rotate(-27.903) scale(36.7359 8.3276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4992 75.9486) rotate(-27.903) scale(36.7398 8.32848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4908 75.9286) rotate(-27.903) scale(36.7398 8.32848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4838 75.908) rotate(-27.903) scale(36.7359 8.3276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4748 75.887) rotate(-27.903) scale(36.7398 8.32848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4668 75.8666) rotate(-27.903) scale(36.7398 8.32848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4602 75.843) rotate(-27.903) scale(36.7359 8.3276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4521 75.8251) rotate(-27.903) scale(36.7321 8.32673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4438 75.8037) rotate(-27.903) scale(36.7359 8.3276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4391 75.7889) rotate(-27.8923) scale(36.7349 8.32891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4291 75.7628) rotate(-27.903) scale(36.7321 8.32676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4236 75.7455) rotate(-27.8923) scale(36.7349 8.32891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4114 75.7209) rotate(-27.903) scale(36.7321 8.32676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4047 75.7007) rotate(-27.903) scale(36.7321 8.32673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3964 75.6794) rotate(-27.903) scale(36.7321 8.32673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3894 75.6594) rotate(-27.903) scale(36.7321 8.32673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3811 75.6362) rotate(-27.903) scale(36.7321 8.32673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3727 75.6181) rotate(-27.903) scale(36.7359 8.3276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.366 75.5968) rotate(-27.903) scale(36.7359 8.32763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3573 75.5766) rotate(-27.903) scale(36.7359 8.32763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.349 75.5556) rotate(-27.903) scale(36.7359 8.3276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3423 75.5348) rotate(-27.903) scale(36.7359 8.3276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3362 75.5194) rotate(-27.8923) scale(36.7349 8.32888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.326 75.4922) rotate(-27.903) scale(36.7359 8.3276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3219 75.4786) rotate(-27.8923) scale(36.7349 8.32888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3103 75.4521) rotate(-27.903) scale(36.7359 8.32762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.306 75.4363) rotate(-27.8923) scale(36.7349 8.3289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2943 75.4097) rotate(-27.903) scale(36.7359 8.32762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2873 75.3895) rotate(-27.903) scale(36.7282 8.32586)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2822 75.372) rotate(-27.8923) scale(36.7388 8.32977)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2719 75.3489) rotate(-27.903) scale(36.7359 8.32762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2629 75.3277) rotate(-27.903) scale(36.7359 8.32762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2589 75.3101) rotate(-27.8923) scale(36.7427 8.33065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1814 81.5347) rotate(-27.696) scale(4.56921 4.81737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_1792_4934",
    x1: 22.4195,
    y1: 89.6956,
    x2: 19.3091,
    y2: 83.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_1792_4934",
    x1: 22.082,
    y1: 88.7695,
    x2: 16.6047,
    y2: 78.3519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_1792_4934",
    x1: 18.3725,
    y1: 78.5302,
    x2: 21.7026,
    y2: 84.8626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_1792_4934",
    x1: 21.5803,
    y1: 87.378,
    x2: 16.4768,
    y2: 77.6556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_1792_4934",
    x1: 21.0975,
    y1: 85.9343,
    x2: 15.1274,
    y2: 74.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_1792_4934",
    x1: 20.2397,
    y1: 83.2084,
    x2: 13.9393,
    y2: 81.7388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.059 83.184) rotate(-76.8723) scale(6.07492 5.24217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_1792_4934",
    x1: 18.7765,
    y1: 81.1842,
    x2: 22.0782,
    y2: 83.6969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F98D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F66300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FF7C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_1792_4934",
    x1: 18.683,
    y1: 81.1361,
    x2: 22.0895,
    y2: 83.8783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDF60"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3758 79.6573) rotate(37.1738) scale(1.26957 1.20051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0882 77.0868) rotate(-33.3426) scale(5.5168 0.183663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.0383 78.6247) rotate(66.3052) scale(5.74241 0.176833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8898 79.4803) rotate(103.175) scale(2.80867 0.0787415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1453 80.4082) rotate(14.3987) scale(2.41234 0.0906647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.8207 80.9082) rotate(65.3926) scale(1.52212 0.4641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4791 79.4657) rotate(141.897) scale(1.48542 0.475575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9664 80.3041) rotate(103.156) scale(0.71592 0.197729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.938 80.8081) rotate(17.7887) scale(0.609991 0.227486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_1792_4934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5089 80.1834) rotate(-76.8723) scale(2.56044 2.20944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E09D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A5742A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#72501D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#493312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#291D0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#120D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.5bcebc2ce3b79d20a805e6d96730f864.svg";
export { ForwardRef as ReactComponent };